import PropTypes from 'prop-types';
import React from 'react';
import Popovers from '../Popovers/Popovers';
import helpers from '../../helpers';
import ShowAllModal from '../ShowAllModal';
import reactT from '../reactT';

class FederatedListFacet extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      filter: '', truncateFacetListsAt: 7, textFilter: '', pendingValue: null,
    };
  }

  handleClick(value) {

    if (typeof value === 'string') {
      value = [value];
    }

    value.forEach((value) => {
      const {
        foundIdx, parsed, isQsParamField, param,
      } = helpers.qs.getFieldQsInfo({
        field: this.props.field, values: this.props.value, value,
      });

      // Define var for new parsed qs params object.
      let newParsed = parsed;

      // If the clicked list facet field is one whose state is tracked in the qs.
      if (isQsParamField) {
        // If the click is adding the field value.
        if (foundIdx < 0) {
          // If there is already a qs param for this field value.
          if (param) {
            // Add value to parsed qs params.
            newParsed = helpers.qs.addValueToQsParam({
              field: this.props.field, value, param, parsed,
            });
          } else {
            // If there is not already a qs param for this field value.
            // Add new qs param for field + value.
            newParsed = helpers.qs.addQsParam({
              field: this.props.field, value, parsed,
            });
          }

          // Send new query based on app state.
          this.props.onChange(this.props.field, this.props.value.concat(value));
        } else {
          // If the click is removing this field value.
          // If their is already a qs param for this field value.
          if (param) {
            newParsed = helpers.qs.removeValueFromQsParam({
              field: this.props.field, value, param, parsed,
            });
          }

          // Send new query based on app state.
          this.props.onChange(this.props.field, this.props.value.filter((v, i) => i !== foundIdx));
        }

        helpers.qs.addNewUrlToBrowserHistory(newParsed);
      }
    });
    if (value.length > 1) {
      window.location.reload();
    }
  }

  getHighlightedText(text, highlight) {
    // Split on highlight term and include term into parts, ignore case
    const parts = text.split(new RegExp(`(${highlight})`, 'gi'));
    return (
      <span>
        {' '}
        {parts.map((part, i) => (
          <span
            key={i}
            className={part.toLowerCase() === highlight.toLowerCase() ? 'font-weight-bold' : ''}
          >
            {part}
          </span>
        ))}
        {' '}

      </span>
    );
  }

  // When the facet is shown in a modal popup we defer applying the filter until
  // the user clicks "Apply" (see UNHCRRW-2406). The selection the user builds up
  // inside the modal is staged in this.state.pendingValue; the inline (on-page)
  // facet list keeps the original behaviour of filtering on each click.

  // Initialise the staged selection when the modal popup opens.
  handleModalOpen() {
    this.setState({ pendingValue: [...this.props.value] });
  }

  // Discard the staged selection when the modal popup is closed without applying
  // (X button, escape key or clicking the backdrop).
  handleModalCancel() {
    this.setState({ pendingValue: null });
  }

  // Toggle one or more facet values within the staged selection. This only
  // mutates local state - no querystring change and no search is run until the
  // user clicks "Apply".
  handleModalToggle(value) {
    if (typeof value === 'string') {
      value = [value];
    }

    this.setState((state) => {
      const pending = state.pendingValue !== null ? [...state.pendingValue] : [...this.props.value];
      value.forEach((v) => {
        const idx = pending.indexOf(v);
        if (idx < 0) {
          pending.push(v);
        } else {
          pending.splice(idx, 1);
        }
      });
      return { pendingValue: pending };
    });
  }

  // Clear the whole staged selection (modal "Clear" button / "Clear selection"
  // link). Still only committed to the search when the user clicks "Apply".
  handleModalClear() {
    this.setState({ pendingValue: [] });
  }

  // Commit the staged selection: sync the querystring for this field and run a
  // single query with the full set of values, then reset the staged state.
  // Called when the user clicks "Apply" in the modal popup.
  handleModalApply() {
    const { field } = this.props;
    const finalValues = this.state.pendingValue !== null ? this.state.pendingValue : this.props.value;

    // Keep the querystring in sync with the applied selection.
    if (helpers.filterFieldsWithQsState.find((item) => item === field)) {
      const { parsed } = helpers.qs.getParsedQsAndParams();
      const newParsed = parsed;
      if (finalValues.length > 0) {
        newParsed[field] = [...finalValues];
      } else {
        delete newParsed[field];
      }
      helpers.qs.addNewUrlToBrowserHistory(newParsed);
    }

    // Run a single search with the full staged set of values.
    this.props.onChange(field, finalValues);
    // Reset the staged state.
    this.setState({ pendingValue: null });
  }

  render() {
    const {
      label, facets, field, value, options, collapse, id, CurrentFacetsCounter, customComponents, onSearchFieldChange, showAllTitle,
    } = this.props;
    const CurrentQueryComponent = customComponents.searchFields.currentQuery;
    const { truncateFacetListsAt, pendingValue } = this.state;
    // While the modal popup is open we render checkbox/selection state from the
    // staged (pending) value instead of the applied value, so toggling a box
    // does not filter the results until the user clicks "Apply".
    const modalValue = pendingValue !== null ? pendingValue : value;
    const { siteList } = options;
    const facetCounts = facets.filter((facet, i) => i % 2 === 1);
    const facetValues = facets.filter((facet, i) => i % 2 === 0);

    // Create an object of facets {value: count} to keep consistent for inputs.
    const facetInputs = {};
    // Facets fields
    const fields = [
      'sm_site_name', 'sm_keywords_name', 'ds_created', 'ss_type', 'ss_collection_name', 'sm_country_name', 'sm_document_source_name', 'sm_document_source_category', 'ss_document_type_name', 'sm_document_subtype_name', 'sm_legal_instruments_name', 'sm_persons_of_concern_name', 'sm_populations_groups_name', 'sm_publisher_category_name', 'sm_country_classification_name', 'sm_languages', 'sm_religious_groups_name', 'sm_judicial_body_name', 'sm_region_name', 'ss_document_status',
    ];

    const langcode = document.querySelector('html').getAttribute('lang');
    // Handle site name restrictions.
    if (field === 'sm_site_name' && siteList.length > 0) {
      facetValues.forEach((v, i) => {
        const key = facetValues[i];
        if (siteList.indexOf(v) > -1) {
          facetInputs[key] = facetCounts[i];
        }
      });
      // If only one option exists and nothing is selected, don't show it.
      if (value.length < 1 && Object.keys(facetInputs).length < 2) {
        return null;
      }
    } else if (fields.includes(field)) {
      let total = 0;
      facetCounts.forEach((v) => {
        total += v;
      });

      if (total < 1) {
        return null;
      }
      facetValues.forEach((v, i) => {
        const key = facetValues[i];
        facetInputs[key] = facetCounts[i];
      });
    } else {
      facetValues.forEach((v, i) => {
        const key = facetValues[i];
        facetInputs[key] = facetCounts[i];
      });
    }

    let vocabularyDescription = '';
    if (typeof drupalSettings !== 'undefined' && id !== undefined) {
      /* global drupalSettings:true */
      if (drupalSettings.facets_vocabularies[id] !== undefined) {
        if (drupalSettings.facets_vocabularies[id].vocabulary_description !== '' && drupalSettings.facets_vocabularies[id].vocabulary_description !== null) {
          vocabularyDescription = drupalSettings.facets_vocabularies[id].vocabulary_description;
        }
      }
    }

    const expanded = !collapse;

    const facetValuesCount = facetValues.filter((facetValue, i) => facetInputs[facetValue] > 0).length;

    const russianPattern = /^[аАбБвВгГдДеЕёЁжЖзЗиИйЙкКлЛмМнНоОпПрРсСтТуУфФхХцЦчЧшШщЩъЪыЫьЬэЭюЮяЯ0-9]+$/ug;
    const spanishPattern = /[A-Za-záÁéÉíÍóÓúÚñÑüÜ0-9]/;
    const englishPattern = /[A-Za-z0-9]/;

    const groupNames = (arr) => {
      const map = arr.reduce((acc, val) => {
        const char = val.charAt(0).toUpperCase();

        let charHandledByLang = '';
        if (langcode === 'ru') {
          charHandledByLang = char.match(russianPattern) ? char : '#';
        } else if (langcode === 'es') {
          charHandledByLang = char.match(spanishPattern) ? char : '#';
        } else if (langcode === 'en') {
          charHandledByLang = char.match(englishPattern) ? char : '#';
        }
        acc[charHandledByLang] = [].concat((acc[charHandledByLang] || []), val);

        return acc;
      }, {});

      const mapObjectKeys = Object.keys(map);
      if (mapObjectKeys[0] === '#') {
        const hash = mapObjectKeys[0];
        delete mapObjectKeys[0];
        mapObjectKeys[mapObjectKeys.length] = hash;
      }

      const res = mapObjectKeys.map((el) => ({
        letter: el, names: map[el],
      }));
      return res;
    };

    const collator = new Intl.Collator(langcode);

    const facetValuesGroupedByFirstChar = (field === 'ss_document_type_name') ? [
      {
        letter: '#',
        names: facetValues,
      },
    ] : groupNames(facetValues.filter((facetValue, i) => facetInputs[facetValue] > 0))
      .sort((a, b) => collator.compare(a.letter, b.letter));

    const sortedFacetValues = facetValues
      .sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()));

    if (field === 'sm_document_source_category' || field === 'sm_document_source_name') {
      let targetValue = '';

      if (typeof drupalSettings !== 'undefined') {
        targetValue = drupalSettings.unhcr_publisher;
      }

      // Find the index of the target element.
      const targetIndex = sortedFacetValues.indexOf(targetValue);

      // If the target element is found, and it's not already the first element.
      if (targetIndex !== -1 && targetIndex !== 0) {
        // Move the target element to the first position
        sortedFacetValues.splice(targetIndex, 1);
        sortedFacetValues.unshift(targetValue);
      }
    }

    // This is not a hierarchy of accordion groups,
    // just render the single list-facet accordion.
    return (
      <div className={`block block-unhcr-search block-${field}`}>
        <div className="accordion-filter pb-0" id={`accordion-${field}`}>
          <div className="card-facet">
            <div
              className="card-header-facet d-flex align-items-center justify-content-between"
              id={label.replace(/\s+/g, '-').toLowerCase()}
            >
              <div
                className="section-accordion-title d-flex justify-content-between align-items-center"
              >
                <div className="d-inline-block">
                  <span>{label}</span>
                  <Popovers text={vocabularyDescription}/>
                </div>
              </div>
              <span
                className={expanded ? 'section-accordion-toggle' : 'section-accordion-toggle collapsed'}
                role="button"
                data-toggle="collapse"
                data-target={`#collapse-${field}`}
                aria-expanded={expanded ? 'true' : 'false'}
                aria-controls={`collapse-${field}`}
                aria-label="Toggle collapse"
              />
            </div>
            <div
              id={`collapse-${field}`}
              className={expanded ? 'collapse show pb-2' : 'collapse pb-2'}
            >
              <div
                className="card-body-facet"
                key={`solr-list-facet-${field}-ul`}
              >
                <ul className="list-unstyled pl-0">
                  {sortedFacetValues
                    .filter((facetValue, i) => facetInputs[facetValue] > 0)
                    .filter((facetValue, i) => i < truncateFacetListsAt)
                    .map((facetValue, i) => {
                      if (this.state.filter.length === 0 || facetValue
                        .toLowerCase()
                        .indexOf(this.state.filter.toLowerCase()) > -1) {
                        let label = facetValue;

                        if (field === 'ss_type' && typeof drupalSettings !== 'undefined') {
                          label = drupalSettings.content_types_labels[facetValue].label;
                        }

                        let termDescription = '';
                        if (typeof drupalSettings !== 'undefined' && id !== undefined && facetValue !== undefined) {
                          if (drupalSettings.facets_vocabularies[id] !== undefined) {
                            if (drupalSettings.facets_vocabularies[id].terms !== '' && drupalSettings.facets_vocabularies[id].terms !== null) {
                              if (drupalSettings.facets_vocabularies[id].terms[facetValue] !== null && drupalSettings.facets_vocabularies[id].terms[facetValue] !== undefined) {
                                termDescription = drupalSettings.facets_vocabularies[id].terms[facetValue].term_description;
                              }
                            }
                          }
                        }

                        return (
                          <li
                            key={`${facetValue}_${facetInputs[facetValue]}`}
                            className="d-flex align-items-baseline search-accordion__checkbox-label"
                          >
                            <input
                              type="checkbox"
                              name={field}
                              id={`${field}_${facetValue.replace(/\s+/g, '_').toLowerCase()}`}
                              value={facetValue}
                              checked={value.indexOf(facetValue) > -1}
                              onChange={() => this.handleClick(facetValue)}
                            />
                            <label
                              className="d-flex align-items-baseline mb-0 ml-2"
                              htmlFor={`${field}_${facetValue.replace(/\s+/g, '_').toLowerCase()}`}
                            >
                              <span className="checkbox-label-text">
                                {field === 'sm_country_classification_name' ? reactT(label) : label}
                                <span className="facet-item-amount">
                                  {' '}
                                  {field !== 'sm_country_classification_name' ? (facetInputs[facetValue] > 0 ? `(${facetInputs[facetValue]})` : '(+)') : ''}
                                  {' '}
                                </span>
                              </span>
                            </label>
                            <Popovers text={termDescription}/>
                          </li>
                        );
                      }
                      return null;
                    })}
                </ul>

                {/* Grouped facets.*/}
                {facetValuesCount > truncateFacetListsAt ? (
                  <ShowAllModal
                    title={label}
                    triggerLabel={`${reactT('Show all')} ${showAllTitle.toLowerCase()}`}
                    filter={(
                      <div className="unhcr-search w-100 mt-3">
                        <div className="view-filters mb-0">
                          <form className="views-exposed-form">
                            <div className="form-row">
                              <div className="form-item-keywords">
                                <input
                                  type="text"
                                  className="form-control bg-white"
                                  name="filter"
                                  id="facetsTextFilter"
                                  value={this.state.textFilter}
                                  onChange={(event) => this.setState({
                                    textFilter: event.target.value,
                                  })}
                                  placeholder={reactT('Search')}
                                />
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    )}
                    clearFilter={() => this.setState({
                      textFilter: '',
                    })}
                    onOpen={() => this.handleModalOpen()}
                    onApply={() => this.handleModalApply()}
                    onCancel={() => this.handleModalCancel()}
                    currentQuery={(
                      <CurrentQueryComponent
                        {...this.props}
                        onChange={onSearchFieldChange}
                        currentQueryType="list-facet"
                        currentQueryField={field}
                        overrideValue={modalValue}
                        onStage={(f, v) => this.handleModalToggle(v)}
                        onClear={(e) => { e.preventDefault(); this.handleModalClear(); }}
                      />
                    )}
                    selectedCount={modalValue.length}
                    onClear={(e) => { e.preventDefault(); this.handleModalClear(); }}
                    CurrentFacetsCounter={CurrentFacetsCounter}
                  >

                    {facetValuesGroupedByFirstChar
                      .map((facetValue, i) => {
                        const filteredFacetValueName = facetValue.names
                          .filter((name) => !this.state.textFilter || name.toLowerCase().includes(this.state.textFilter.toLowerCase()));

                        if (filteredFacetValueName.length > 0) {
                          if (field !== 'ss_document_type_name') {
                            return (
                              <div
                                className="facet-modal-group"
                                key={`facet-modal-group-${i}`}
                              >
                                <h5>{facetValue.letter}</h5>
                                <ul className="list-unstyled pl-0">
                                  {filteredFacetValueName
                                    .sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()))
                                    .map((facetValueName, i) => {
                                      if (this.state.filter.length === 0 || facetValueName
                                        .toLowerCase()
                                        .indexOf(this.state.filter.toLowerCase()) > -1) {
                                        let label = facetValueName;

                                        if (field === 'ss_type' && typeof drupalSettings !== 'undefined') {
                                          label = drupalSettings.content_types_labels[facetValueName].label;
                                        }

                                        let termDescription = '';
                                        if (typeof drupalSettings !== 'undefined' && id !== undefined && facetValueName !== undefined) {
                                          if (drupalSettings.facets_vocabularies[id] !== undefined) {
                                            if (drupalSettings.facets_vocabularies[id].terms !== '' && drupalSettings.facets_vocabularies[id].terms !== null) {
                                              if (drupalSettings.facets_vocabularies[id].terms[facetValueName] !== null && drupalSettings.facets_vocabularies[id].terms[facetValueName] !== undefined) {
                                                termDescription = drupalSettings.facets_vocabularies[id].terms[facetValueName].term_description;
                                              }
                                            }
                                          }
                                        }
                                        return (
                                          <li
                                            key={`${facetValueName}_${facetInputs[facetValueName]}`}
                                            className="d-flex align-items-baseline search-accordion__checkbox-label"
                                          >
                                            <input
                                              type="checkbox"
                                              name={field}
                                              id={`modal-${field}_${facetValueName.replace(/\s+/g, '_').toLowerCase()}`}
                                              value={facetValueName}
                                              checked={modalValue.indexOf(facetValueName) > -1}
                                              onChange={() => this.handleModalToggle(facetValueName)}
                                            />
                                            <label
                                              className="d-flex align-items-baseline mb-0 ml-2"
                                              htmlFor={`modal-${field}_${facetValueName.replace(/\s+/g, '_').toLowerCase()}`}
                                            >
                                            <span
                                              className="checkbox-label-text">
                                              {this.getHighlightedText(field === 'sm_country_classification_name' ? reactT(label) : label, this.state.textFilter)}
                                              <span
                                                className="facet-item-amount">
                                                {' '}
                                                {field !== 'sm_country_classification_name' ? (facetInputs[facetValueName] > 0 ? `(${facetInputs[facetValueName]})` : '(+)') : ''}
                                                {' '}
                                              </span>
                                            </span>
                                            </label>
                                            <Popovers text={termDescription}/>
                                          </li>
                                        );
                                      }
                                      return null;
                                    })}
                                </ul>
                              </div>
                            );
                          }
                          if (field === 'ss_document_type_name') {
                            let jsonData = {};
                            if (typeof drupalSettings !== 'undefined' && drupalSettings.facets_hierarchy_document_type !== 'undefined') {
                              const jsonString = drupalSettings.facets_hierarchy_document_type;

                              try {
                                jsonData = JSON.parse(jsonString);
                                // Now, jsonData is an object.
                              } catch (error) {
                                console.error('Error parsing JSON string:', error);
                              }
                            }

                            const organizeArray = (array, data) => {
                              const result = [];

                              array.forEach((item) => {
                                let category = item;
                                let subcategory = data[item];

                                // Check if the subcategory is also a category.
                                while (subcategory && data[subcategory]) {
                                  category = subcategory;
                                  subcategory = data[category];
                                }

                                if (subcategory === undefined || subcategory === null) {
                                  subcategory = null; // Set subcategory to null for items under undefined or null.
                                }

                                // Check for duplicates and exclude items from the null array.
                                if (!result.some((item) => item.category === category) && subcategory !== null) {
                                  result.push({ category, parent: subcategory });
                                }

                                // If the category is not in jsonData, add it to result with empty parent.
                                if (!data[category] && !result.some((item) => item.category === category)) {
                                  result.push({ category, parent: category });
                                }
                              });

                              // Move categories of empty subcategories to parent level.
                              result.forEach((item) => {
                                if (item.parent !== null && !result.some((parentItem) => parentItem.category === item.parent)) {
                                  facetValues.unshift(item.parent); // Use unshift to add to the beginning of the array.
                                  result.unshift({ category: item.parent, parent: item.parent });
                                }
                              });

                              return result;
                            };

                            const data = organizeArray(facetValues, jsonData);

                            data.sort((a, b) => {
                              // Compare the values of parent and category
                              const aIsEqual = a.parent === a.category;
                              const bIsEqual = b.parent === b.category;

                              // Sort in such a way that objects with parent === category come first
                              if (aIsEqual && !bIsEqual) {
                                return -1;
                              }
                              if (!aIsEqual && bIsEqual) {
                                return 1;
                              }

                              // For other cases, maintain the order
                              return 0;
                            });

                            return (
                              <ul key="main-category"
                                  className="list-unstyled pl-0 parent">
                                {data
                                  .filter((item) => !this.state.textFilter || item.category.toLowerCase().includes(this.state.textFilter.toLowerCase()))
                                  .filter(
                                    // Filter parents that has childern with selected values.
                                    (item) => data
                                        .filter((childItem) => childItem.parent === item.category && childItem.category !== item.category)
                                        .filter((childItem) => facetInputs[childItem.category] > 0)
                                        .map((childItem) => facetInputs[childItem.category])
                                        .reduce((acc, currentValue) => acc + currentValue, 0)
                                      + (facetInputs[item.category] > 0 ? facetInputs[item.category] : 0) > 0,
                                  )
                                  .sort((a, b) => (a.parent || '').toLowerCase().localeCompare((b.parent || '').toLowerCase()))
                                  .map((parentItem) => {
                                    if (this.state.filter.length === 0 || parentItem.category
                                      .toLowerCase()
                                      .indexOf(this.state.filter.toLowerCase()) > -1) {
                                      let parentTermDescription = '';
                                      const id = 'document_type';

                                      if (typeof drupalSettings !== 'undefined' && parentItem.category !== undefined) {
                                        if (drupalSettings.facets_vocabularies[id] !== undefined) {
                                          if (drupalSettings.facets_vocabularies[id].terms !== '' && drupalSettings.facets_vocabularies[id].terms !== null) {
                                            if (drupalSettings.facets_vocabularies[id].terms[parentItem.category] !== null && drupalSettings.facets_vocabularies[id].terms[parentItem.category] !== undefined) {
                                              parentTermDescription = drupalSettings.facets_vocabularies[id].terms[parentItem.category].term_description;
                                            }
                                          }
                                        }
                                      }

                                      let classes = parentItem.parent !== parentItem.category ? 'sub-category' : 'category';
                                      classes += ` ${parentItem.parent.replace(/[^\w\d\u00C0-\u024F\u0400-\u04FF]+/g, '_').toLowerCase()}`;

                                      return (
                                        <li
                                          key={`${parentItem.category}_${facetInputs[parentItem.category]}`}
                                          className={
                                            `d-flex align-items-baseline search-accordion__checkbox-label ${classes}`
                                          }>
                                          <div
                                            className="d-flex align-items-baseline ">
                                            {facetInputs[parentItem.category] > 0 ?
                                              (<input
                                                type="checkbox"
                                                name={field}
                                                id={`modal-${field}_${parentItem.category.replace(/[^\w\d\u00C0-\u024F\u0400-\u04FF]+/g, '_').toLowerCase()}`}
                                                value={parentItem.category}
                                                checked={modalValue.indexOf(parentItem.category) > -1}
                                                onChange={
                                                  () => {
                                                    this.handleModalToggle(parentItem.category);
                                                    // let checkboxValues = [];
                                                    // const childCheckboxes = document.querySelectorAll(`.${parentItem.category.replace(/[^\w\d\u00C0-\u024F\u0400-\u04FF]+/g, '_').toLowerCase()}`);
                                                    // childCheckboxes.forEach((checkbox) => {
                                                    //   checkboxValues.push(checkbox.querySelector('input').value);
                                                    // });
                                                    //
                                                    // if (checkboxValues.length === 1) {
                                                    //   this.handleClick(parentItem.category);
                                                    // } else {
                                                    //   this.handleClick(checkboxValues);
                                                    // }
                                                  }
                                                }
                                              />)
                                              : (null)
                                            }

                                            <label
                                              className="d-flex align-items-baseline mb-0"
                                              htmlFor={`modal-${field}_${parentItem.category.replace(/[^\w\d\u00C0-\u024F\u0400-\u04FF]+/g, '_').toLowerCase()}`}
                                            >
                                              <span
                                                className="checkbox-label-text">
                                                {this.getHighlightedText(field === 'sm_country_classification_name' ? reactT(label) : parentItem.category, this.state.textFilter)}
                                                <span
                                                  className="facet-item-amount">
                                                  {' '}
                                                  {
                                                    // data
                                                    //   .filter((childItem) => childItem.parent === parentItem.category && childItem.category !== parentItem.category)
                                                    //   .filter((childItem) => facetInputs[childItem.category] > 0)
                                                    //   .map((childItem) => facetInputs[childItem.category])
                                                    //   .reduce((acc, currentValue) => acc + currentValue, 0)
                                                    // + (facetInputs[parentItem.category] > 0 ? facetInputs[parentItem.category] : 0)
                                                    facetInputs[parentItem.category] > 0 ? '(' + facetInputs[parentItem.category] + ')' : ''
                                                  }
                                                  {' '}
                                                </span>
                                              </span>
                                            </label>
                                            <Popovers
                                              text={parentTermDescription}/>
                                          </div>
                                        </li>
                                      );
                                    }
                                  })}
                              </ul>
                            );
                          }
                        }
                        return null;
                      })}

                  </ShowAllModal>
                ) : ''}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

FederatedListFacet.defaultProps = {
  hierarchy: false, expandedHierarchies: [], value: [],
};

FederatedListFacet.propTypes = {
  bootstrapCss: PropTypes.bool, children: PropTypes.array, collapse: PropTypes.bool, expandedHierarchies: PropTypes.array, facetSort: PropTypes.string, facets: PropTypes.array.isRequired, field: PropTypes.string.isRequired, hierarchy: PropTypes.bool, label: PropTypes.string, onChange: PropTypes.func, onFacetSortChange: PropTypes.func, onSetCollapse: PropTypes.func, query: PropTypes.object, truncateFacetListsAt: PropTypes.number, value: PropTypes.array,
};

export default FederatedListFacet;
